
import { Component, mixins } from 'nuxt-property-decorator';
import WebsiteNavigationLinkMixin from './WebsiteNavigationLinkMixin';

@Component
export default class WebsiteNavigationNestedLink extends mixins(WebsiteNavigationLinkMixin) {}
